import download from 'downloadjs';

const downloadDocument = (contentType: any, fileName: string, data: any) => {
  download(data, `${fileName}.xlsx`, contentType);
};

export default downloadDocument;
